import script from "./EvaluationAreas.vue?vue&type=script&setup=true&lang=js"
export * from "./EvaluationAreas.vue?vue&type=script&setup=true&lang=js"

import "./EvaluationAreas.vue?vue&type=style&index=0&id=32346fdd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32346fdd"]])

export default __exports__